import React from "react";
import hostelimage from "../images/aaaa.jpg";
import image2 from "../images/pro.jpg";
import image3 from "../images/2.jpg";
import amazonlogo from "../images/amazon 2.PNG";
import "./project.css";
import netfliximage from "../images/netflix.PNG";
import Footer from "./Footer";
const Services = () => {
  return (
    <div className="container">
      <div className="projects-content">
        <div className="row project-row">
          <div
            className="col-lg-4 col-md-6 col-sm-12"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="project-box">
              <img src={hostelimage} className="project-image" />
              <p>Hostel Registration Form</p>
              <a href="https://web-development-d7093.web.app/" target="_blank">
                <button className="project-button">Check out</button>
              </a>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12" data-aos="zoom-in">
            <div className="project-box">
              <img src={image2} className="project-image2" />
              <p>Informational site of our team</p>
              <a href="https://developers-531d0.web.app/" target="_blank">
                <button className="project-button">Check out</button>
              </a>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6 col-sm-12"
            data-aos="fade-down"
            data-aos-duration="3000"
          >
            <div className="project-box">
              <img src={image3} className="project-image3" />
              <p>Simple Form Validation</p>
              <a href="https://form-validation-71e27.web.app/" target="_blank">
                <button className="project-button">Check out</button>
              </a>
            </div>
          </div>
        </div>
        <div className="row project-row2">
          <div
            className="col-lg-4 col-md-6 col-sm-12"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="project-box">
              <img src={amazonlogo} className="project-image4" />
              <p>Clone af Amazon.com</p>
              <a href="https://clone-5e97a.web.app/" target="_blank">
                <button className="project-button">Check out</button>
              </a>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12" data-aos="zoom-in">
            <div className="project-box">
              <img src={netfliximage} className="project-image" />
              <p>Clone of Netflix</p>
              <a href="https://netflix-clone-2aabe.web.app/" target="_blank">
                <button className="project-button">Check out</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="heading">
                    <h1>Projects</h1>
                </div>

            <div className="container" className="d-flex justify-content-center">
            <div className="cards">
                <div className="row">
                    <div data-aos="fade-left" className="col-lg-4 col-md-4  col-sm-12">
                        <Card imgsrc={hostelimage} title="HTML5" text="Hostel Registration form" hrf="https://web-development-d7093.web.app/" />
                    </div>
                    <div data-aos="fade-up" className="col-lg-4 col-md-4 col-sm-12">
                        <Card imgsrc={image2} title="Project made on HTML CSS" text="Developers" hrf="https://developers-531d0.web.app/" />
                    </div>
                    <div data-aos="fade-right" className="col-lg-4 col-md-4-col-sm-12">
                        <Card imgsrc={image3} title="React" text="Form Validation" hrf="https://form-validation-71e27.web.app/" />
                    </div>
                </div>
               
               
                <div className="row">
                <div data-aos="fade-right" className="col-lg-4 col-md-4-col-sm-12">
                        <Card className="text-align-center" imgsrc={amazonlogo} title="Made clone of Aamazon Website using React.js" text="You can have a look" hrf="http://clone-5e97a.web.app/" />
                    </div>
                </div>


            </div>
            </div>F */}
      <Footer />
    </div>
  );
};

export default Services;
